import React, { useState } from 'react';
import useConfirm from '../hooks/useConfirm';
import useAlert from '../hooks/useAlert';
import { useNavigate } from 'react-router-dom';
import Vista from './layout/Vista';
import RubricaFilterBar from './rubrica/FilterBar';
import ContactListRow from './rubrica/ListRow';
import { deleteContatti } from '../api';
import { showError } from '../utils';
import { ReactComponent as IconAdd } from '../assets/icons/plus.svg';
import { ReactComponent as IconTrash } from '../assets/icons/trash.svg';
import { ReactComponent as IconExportVCF } from '../assets/icons/export.svg';
import { ReactComponent as IconLoading } from '../assets/icons/spinner.svg';

export default function Rubrica({ initialSearchterm = '' }) {
    const navigate = useNavigate();
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [isLoadingDel, setIsLoadingDel] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const confirm = useConfirm();
    const alert = useAlert();

    const handleExportVCF = async () => {
        if (selectedContacts.length === 0) {
            alert({ message: "Nessun contatto selezionato per l'esportazione.", type: 'error' });
            return;
        }

        const vCardData = selectedContacts.map(contact => {
            return `BEGIN:VCARD
                    VERSION:3.0
                    FN:${contact.nome} ${contact.cognome}
                    N:${contact.cognome};${contact.nome};;;
                    TEL;TYPE=CELL:${contact.numtel}
                    END:VCARD`;
        }).join('\n');

        const blob = new Blob([vCardData], { type: 'text/vcard' });
        const file = new File([blob], 'rubrica.vcf', { type: 'text/vcard' });

        const isSafariPWA = window.navigator.standalone === true && /iPhone|iPad|iPod/.test(navigator.userAgent);

        if (isSafariPWA && navigator.canShare && navigator.canShare({ files: [file] })) {
            try {
                await navigator.share({
                    title: 'Rubrica esportata',
                    text: 'Ecco i contatti in formato vCard',
                    files: [file],
                });
                alert({ message: 'File condiviso con successo.' });
            } catch (err) {
                alert({ message: 'Condivisione annullata o fallita: ' + err, type: 'error' });
            }
        } else {
            // Android o fallback: download classico
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'rubrica.vcf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    };

    const handleDeleteContacts = async () => {
        if (selectedContacts.length === 0) {
          alert({message: "Nessun contatto selezionato per l'eliminazione.", type: 'error'});
          return;
        }
        const ok = await confirm({
          message: `Sei sicuro di voler eliminare ${selectedContacts.length} contatt${selectedContacts.length>1?'i':'o'}?`,
        });
        if (ok) performDeleteContacts();
    };

    const performDeleteContacts = async () => {
        setIsLoadingDel(true);
        try {
          await deleteContatti(selectedContacts.map(c => c.id));
          alert({message: `${selectedContacts.length} contatti eliminati con successo.`, type: 'success'});
          setRefresh(prev => !prev);
          setSelectedContacts([]);
        } catch(err) {
          showError([err.message]);
        } finally {
          setIsLoadingDel(false);
        }
    };

    const actions = [
        {
            label: "Crea nuovo",
            icon:  <IconAdd/>,
            onClick: () => navigate('/contatto'),
            className: "add-btn"
        },
        {
            label: "Elimina",
            icon: isLoadingDel ? <IconLoading className="icon-loading"/> : <IconTrash/>,
            onClick: handleDeleteContacts,
            className: "add-btn"
        },
        {
            label: "Esporta in VCF",
            icon: <IconExportVCF/>,
            onClick: handleExportVCF,
            className: "export-btn"
        },       
    ];

    return (        
        <Vista
            key={refresh}
            apiCallEndpoint={"/listacontatti"}
            initialFilterParams={{ searchterm: initialSearchterm }}
            FilterBarComponent={RubricaFilterBar}
            ListRowComponent={ContactListRow}
            actions={actions}
            selectable={true}
            onSelectionChange={(selectedIds, selectedItems) => setSelectedContacts(selectedItems)}
            endMessage="Non ci sono altri contatti"
        />      
    );
}